
    <div class="general-popup-content">
      <a
        href="#"
        (click)="$event.preventDefault(); reject()"
        class="icon close-popup"
        data-id="modalAlert-close-button"
      >
        <i class="fal fa-times"></i>
      </a>
      <!--
        <button class="close" [class.no-hero]="!hero" type="button" (click)="reject()">
          <i class="fal fa-times"></i>
        </button>
      -->
      <div class="general-popup-hero" *ngIf="hero">
        <div class="bonus-edg-value">
          <div translate>{{ hero }}</div>
        </div>
      </div>
      <div class="general-popup-text-wrap">
        <h2 translate>{{ title }}</h2>
        <p translate [innerHtml]="text"></p>
        <app-form-button class="btn primary" (click)="close()" translate data-id="modalAlert-ok-button">
          {{ ok }}
        </app-form-button>
        <app-form-button
          class="btn cancel"
          (click)="reject()"
          *ngIf="cancel"
          translate
          data-id="modalAlert-cancel-button"
        >
          {{ cancel }}
        </app-form-button>
      </div>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/alert-modal.component.ts.AlertModalComponent.html